import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltungs-typen-entity-types';
import * as api from '../../../clients/veranstaltungstypen';

@Injectable()
export class VeranstaltungstypenVeranstaltungsTypenEntityTypesEffects {

    VeranstaltungsTypenEntityTypes$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNGS_TYPEN_ENTITY_TYPES),
        mergeMap((x: ac.GetVeranstaltungsTypenEntityTypesAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungsTypenEntityTypes().pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungsTypenEntityTypesErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungsTypenEntityTypesFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungsTypenTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungsTypenTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungsTypenTemplatesService);
        }
        return this.service;
    }
}
